module.exports = __webpack_public_path__ + "img/PPIDR.dfbca80e.jpeg";